import { Auth0Provider } from '@auth0/auth0-react';
import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

const domain = import.meta.env.VITE_AUTH0_DOMAIN;
const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID;
const audience = import.meta.env.VITE_AUTH0_AUDIENCE;
const redirectUri =
  import.meta.env.VITE_AUTH0_REDIRECT_URI ?? `${window.location.origin}/auth/callback`;

export function AppAuthProvider({ children }: { children: ReactNode }) {
  const navigate = useNavigate();
  if (!domain || !clientId || !audience) {
    throw new Error('Missing Auth0 env vars (VITE_AUTH0_DOMAIN, _CLIENT_ID, _AUDIENCE)');
  }
  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: redirectUri,
        audience,
        scope: 'openid profile email',
      }}
      onRedirectCallback={(appState) => {
        navigate(appState?.returnTo ?? '/', { replace: true });
      }}
      cacheLocation="localstorage"
    >
      {children}
    </Auth0Provider>
  );
}
